import {
  GET_CAMPUSES_AND_ABSENCES_PENDING,
  GET_CAMPUSES_AND_ABSENCES_FAIL,
  GET_CAMPUSES_FOR_ABSENCES_SUCCESS,
  GET_ACTIVE_ABSENCES_PENDING,
  GET_ACTIVE_ABSENCES_SUCCESS,
  GET_ACTIVE_ABSENCES_FAIL,
  CLEAR_ABSENCES_REDUCER,
} from '../constants/ActionTypes';

export const getCampusesAndAbsencesPending = (query = {}, params = {}, affectQuery = false) => ({
  type: GET_CAMPUSES_AND_ABSENCES_PENDING,
  payload: { query, params, affectQuery },
});

export const getCampusesAndAbsencesFail = () => ({
  type: GET_CAMPUSES_AND_ABSENCES_FAIL,
});

export const getCampusesForAbsencesSuccess = (campuses = []) => ({
  type: GET_CAMPUSES_FOR_ABSENCES_SUCCESS,
  payload: { campuses },
});

export const getActiveAbsencesPending = (query = {}, params = {}, affectQuery = false) => ({
  type: GET_ACTIVE_ABSENCES_PENDING,
  payload: { query, params, affectQuery },
});

export const getActiveAbsencesSuccess = (absences = [], pageCount = 1) => ({
  type: GET_ACTIVE_ABSENCES_SUCCESS,
  payload: { absences, pageCount },
});

export const getActiveAbsencesFail = () => ({
  type: GET_ACTIVE_ABSENCES_FAIL,
});

export const clearAbsencesReducer = () => ({
  type: CLEAR_ABSENCES_REDUCER,
});
